import { Component, OnInit, ViewChild } from '@angular/core';
import { ChatSidebarComponent } from './components/chat-sidebar/chat-sidebar.component';
import { ChatDocumentComponent } from './components/chat-document/chat-document.component';
import { ChatMainComponent } from './components/chat-main/chat-main.component';

@Component({
    selector: 'app-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
    @ViewChild(ChatMainComponent) appChatMain: ChatMainComponent;
    @ViewChild(ChatDocumentComponent) appChatDocument: ChatDocumentComponent;
    @ViewChild(ChatSidebarComponent) appChatSidebar: ChatSidebarComponent;
    isSidebarCollapsed: boolean = false;
    isMobileScreen: boolean = false;

    constructor() {}

    ngOnInit(): void {
        this.isMobileScreen = window.innerWidth <= 480;
        this.isSidebarCollapsed = this.isMobileScreen;
    }

    toggleSidebar(): void {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
